module.exports = __webpack_public_path__ + "img/application_bg4.51adead7.jpg";